import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  CircularProgress,
  Dialog,
  Button,
  TextField,
  DialogContent,
  IconButton,
  Tooltip,
  Checkbox,
  Box,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
} from "@mui/material";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar.jsx";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import styles from "./rfp.module.css";
import Swal from "sweetalert2";
import RecceReport from "./RecceReport.js";
import axios from "axios";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ClientRecceRejectedModal from "./ClientRecceRejectedModal.js";
import ClientRecceApprovalModal from "./ClientRecceApprovalModal.js";
import ClientRecceHoldOnModal from "./ClientRecceHoldOnModal.js";
import socket from "../../../shared/utils/Socket.js";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter.jsx";
import TemplateModal from "../../LandingPages/TemplateModal.js";
import Back from "../../../shared/assets/icons/Back.jsx";
import ClientStatCards from "../../ClientDashboard/ClientStatCards.js";
import ClientApprovalFilters from "../../ClientDashboard/ClientApprovalFilters.jsx";
import CopyIcon from "../../../shared/assets/icons/CopyIcon.jsx";
import ReportIcon from "../../../shared/assets/icons/ReportIcon.jsx";
import ApprovIcon from "../../../shared/assets/icons/ApprovIcon.jsx";
import HoldOnIcon from "../../../shared/assets/icons/HoldOnIcon.jsx";
import RejectIcon from "../../../shared/assets/icons/RejectIcon.jsx";
import ApproveIconWithoutBorder from "../../../shared/assets/icons/ApproveIconWithoutBorder.jsx";
import RejectWithoutBorder from "../../../shared/assets/icons/RejectWithoutBorder.jsx";
import HoldOnWithoutBorder from "../../../shared/assets/icons/HoldOnWithoutBorder.jsx";
import GlobalDropdownField from "../../../shared/utils/GlobalDropdownField.jsx";
import DragDropUpload from "../../AdminportalFolder/DragDropUpload.jsx";
import { ImageOutlined } from "@mui/icons-material";
import sortRowsAlphabetically from "../../../shared/utils/sortRowsAlphabetically.js";

const STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: -1,
  HOLD: 2,
};

const RecceApprovalTable = ({
  role = "client",
  setClientApprovalOpen,
  username,
}) => {
  const { id } = useParams();
  const navigate = useNavigate(); // Initialize navigation

  const [finalSpaces, setFinalSpaces] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100, 200, 500];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [campaignListLoading, setCampaignListLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [heldProducts, setHeldProducts] = useState({});
  const [ignoredProducts, setIgnoredProducts] = useState({});
  const [approvedProducts, setApprovedProducts] = useState({});
  const [open, setOpen] = useState(false);
  const [currentApproval, setCurrentApproval] = useState();
  const [jobApprovals, setJobApprovals] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [client, setClient] = useState(null);
  const [isPreviewCompletionReport, setPreviewCompletionReport] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [holdOnModalOpen, setHoldOnModalOpen] = useState(false);
  const [rejectionModalOpen, setRejectionModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState({
    id: null,
    data: null,
    productId: null,
  });
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedApprovals, setSelectedApprovals] = useState([]);

  const [selectedApproval, setSelectedApproval] = useState([]);
  const [storeSortOrder, setStoreSortOrder] = useState(null);
  const [zoneSortOrder, setZoneSortOrder] = useState(null);
  const [search, setSearch] = useState("");
  const didMountSearch = useRef(false);
  const searchTimeoutRef = useRef(null);
  const isInitialMount = useRef(true);

  const [searchInputs, setSearchInputs] = useState({
    city: "",
    state: "",
    productType: "",
    adminStatus: "",
    clientStatus: "",
    store: [],
  });
  const [allApprovals, setAllApprovals] = useState([]);
  const [openCreative, setOpenCreative] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [creativeFile, setCreativeFile] = useState("");
  const [hoveredImage, setHoveredImage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [uploadMode, setUploadMode] = useState("single");
  const [creativeDescription, setCreativeDescription] = useState("");
  const [counts, setCounts] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
    holdOn: 0,
    total: 0,
  });
  const [isUserAction, setIsUserAction] = useState(false);
  const isUserActionRef = useRef(false);
  let isFirstCallRef = useRef(true);
  const isInitialFilterSetRef = useRef(false);

  const sortByStoreName = useCallback(() => {
    const nextSortOrder = storeSortOrder === "asc" ? "desc" : "asc";
    setJobApprovals(
      sortRowsAlphabetically(
        jobApprovals,
        (approval) => approval?.job?.storeName,
        nextSortOrder,
      ),
    );
    // setFilterJobApprovals(sorted.filter((f) => f.clientStatus !== -1));
    setStoreSortOrder(nextSortOrder);
  }, [jobApprovals, storeSortOrder]);

  const sortByZone = useCallback(() => {
    const nextSortOrder = zoneSortOrder === "asc" ? "desc" : "asc";
    setJobApprovals(
      sortRowsAlphabetically(
        jobApprovals,
        (approval) => approval?.job?.zone,
        nextSortOrder,
      ),
    );
    setZoneSortOrder(nextSortOrder);
  }, [jobApprovals, zoneSortOrder]);

  const [allCitiesByState, setAllCitiesByState] = useState([]);

  const initialFilters = {
    state: [""],
    city: [""],
    store: [""],
    zone: [""],
    productType: [""],
    status: [""],
  };
  const [filters, setFilters] = useState(initialFilters);

  const [filterOptions, setFilterOptions] = useState({
    cityOptions: [],
    stateOptions: [],
    storeOptions: [],
    zoneOptions: [],
    productTypeOptions: [],
    statusOptions: [
      { value: "0", label: "Pending" },
      { value: "1", label: "Approved" },
      { value: "-1", label: "Rejected" },
    ],
  });
  const [productList, setProductList] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
    autoHideDuration: 2000,
  });

  const serverURL = process.env.REACT_APP_URL;
  const token = localStorage.getItem("token");

  // Helper function to update user action flag
  const updateUserAction = useCallback((value) => {
    setIsUserAction(value);
    isUserActionRef.current = value;
  }, []);

  const fetchItemMasterProductList = useCallback(
    async (campaignId) => {
      try {
        const res = await fetch(
          `${serverURL}/itemMaster/all-product-type?campaignId=${campaignId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const data = await res.json();

        return data?.products || [];
      } catch (error) {
        console.error("Error fetching item master product list:", error);
        return [];
      }
    },
    [serverURL],
  );
  const handleMultiSelectAll = useCallback((value, prev, options) => {
    if (!Array.isArray(value)) return [];

    const optionValues = options.map((o) => o.value);

    const added = value.find((v) => !prev.includes(v));
    const removed = prev.find((v) => !value.includes(v));

    // 👉 CASE 1: ALL selected
    if (added === "") {
      return ["", ...optionValues];
    }

    // 👉 CASE 2: ALL removed
    if (removed === "") {
      return [];
    }

    // 👉 CASE 3: If ALL was selected & one removed
    if (prev.includes("") && removed) {
      return optionValues.filter((v) => v !== removed);
    }

    // 👉 CASE 4: Normal selection
    if (value.length === optionValues.length) {
      return ["", ...optionValues];
    }

    return value.filter((v) => v !== "");
  }, []);

  const latestRequestRef = React.useRef(0);
  const getApprovalList = useCallback(
    async (filters = {}, searchTerm = "") => {
      if (isUserActionRef.current) {
        return;
      }
      const requestId = ++latestRequestRef.current;
      setIsLoading(true);

      try {
        const response = await axios.get(
          `${serverURL}/installationPartnerJobApproval/viewAllJobApprovals?page=${page}&limit=${pageSize}`,
          {
            headers: { Authorization: `Bearer ${token}` },

            params: {
              campaignId: id,
              adminStatus: ["1"],
              city: filters.city?.includes("") ? [] : filters.city || [],

              state: filters.state?.includes("") ? [] : filters.state || [],

              store: filters.store?.includes("") ? [] : filters.store || [],
              zone: filters.zone?.includes("") ? [] : filters.zone || [],
              productType: filters.productType?.includes("")
                ? []
                : filters.productType || [],

              clientStatus: filters.status?.includes("")
                ? []
                : filters.status || [],
              search: searchTerm || filters.search || "",
            },
          },
        );
        if (requestId != latestRequestRef.current) return;
        if (response?.data?.success) {
          setIsLoading(false);
          const approvals = response.data.data || [];
          setAllApprovals(approvals);
          setJobApprovals(approvals);
          setClient(response.data.clientData[0]);
          // remove comment for pagination
          setTotalPages(response?.data?.totalCountResult);
          // end remove comment for pagination

          setPreviewCompletionReport(response?.data?.isAllJobsDone);
          setCityOptions(response?.data?.cityOptions);
          setSelectedApprovals([]);
          setIsSelectAll(false);
          setCounts({
            stores: response.data.approvedStoreNames.length || 0,
            approved: response.data.approvedCount || 0,
            rejected: response.data.rejectedCount || 0,
            holdOn: response.data.holdOnCount || 0,
            total: response.data.count || 0,
            pending: response.data.pendingCount || 0,
          });
          // Format options
          const formattedCityOptions = (response?.data?.cityOptions || [])
            .filter((city) => {
              const label = typeof city === "string" ? city : city?.label;
              return label && label !== "All";
            })
            .map((city) =>
              typeof city === "string" ? { label: city, value: city } : city,
            );

          const formattedStateOptions = (response?.data?.stateOptions || [])
            .filter((state) => {
              const label = typeof state === "string" ? state : state?.label;
              return label && label !== "Select State" && label !== "All";
            })
            .map((state) =>
              typeof state === "string"
                ? { label: state, value: state }
                : state,
            );

          const formattedStoreOptions = (response?.data?.storeOptions || [])
            .filter((store) => {
              const label = typeof store === "string" ? store : store?.label;
              return label && label !== "Select Store" && label !== "All";
            })
            .map((store) =>
              typeof store === "string"
                ? { label: store, value: store }
                : store,
            );
          const formattedZoneOptions = (response?.data?.zoneOptions || [])
            .filter((zone) => {
              const label = typeof zone === "string" ? zone : zone?.label;
              return label && label !== "All";
            })
            .map((zone) =>
              typeof zone === "string" ? { label: zone, value: zone } : zone,
            );
          // Build city-state mapping from current response data
          const citiesStateMapping = {};
          if (response?.data?.data && Array.isArray(response?.data?.data)) {
            response?.data?.data.forEach((approval) => {
              const state = approval?.job?.state;
              const city = approval?.job?.city;
              if (state && city) {
                if (!citiesStateMapping[state]) citiesStateMapping[state] = [];
                if (!citiesStateMapping[state].includes(city)) {
                  citiesStateMapping[state].push(city);
                }
              }
            });
          }

          if (isFirstCallRef.current) {
            setAllCitiesByState(citiesStateMapping);
            isFirstCallRef.current = false;
          }

          // Use ALL product types from backend (unfiltered)
          const allProductTypes = (
            response?.data?.allProductTypeOptions ||
            response?.data?.productTypeOptions ||
            []
          ).filter((type) => {
            const label = typeof type === "string" ? type : type?.label;
            return label && label !== "All";
          });

          const formattedAllProductTypes = allProductTypes.map((type) =>
            typeof type === "string" ? { label: type, value: type } : type,
          );
          setFilterOptions({
            cityOptions: formattedCityOptions,
            stateOptions: formattedStateOptions,
            storeOptions: formattedStoreOptions,
            zoneOptions: formattedZoneOptions,
            productTypeOptions: formattedAllProductTypes,
            statusOptions: filterOptions.statusOptions,
          });
        }
      } catch (error) {
        setIsLoading(false);

        console.error("Error fetching campaign:", error);
      }
    },
    [serverURL, token, id, page, pageSize, filterOptions.statusOptions],
  );

  const handleFilterChange = useCallback(
    (e, key) => {
      let value = e.target.value;
      const prev = filters[key] || [];
      setPage(1);

      const optionsMap = {
        state: filterOptions.stateOptions,
        city: filterOptions.cityOptions,
        store: filterOptions.storeOptions,
        zone: filterOptions.zoneOptions,
        productType: filterOptions.productTypeOptions,
        status: filterOptions.statusOptions,
      };

      let updatedValue = handleMultiSelectAll(
        value,
        prev,
        optionsMap[key] || [],
      );
      let updatedFilters = {
        ...filters,
        [key]: updatedValue,
      };

      if (key === "city") {
        updatedFilters.store = [];
        const allValues = (() => {
          const stateValues = filters.state || [];
          const cleanStates = stateValues.includes("ALL")
            ? Object.keys(allCitiesByState)
            : stateValues.length === 0
              ? Object.keys(allCitiesByState)
              : stateValues;
          const citiesForStates = cleanStates.flatMap(
            (st) => allCitiesByState[st] || [],
          );
          return cityOptions
            .filter((city) => citiesForStates.includes(city.value))
            .map((c) => c.value);
        })();
        let incoming = Array.isArray(value) ? value : [value];
        const added = incoming.find((v) => !prev.includes(v));
        const removed = prev.find((v) => !incoming.includes(v));

        if (added === "") {
          updatedValue = ["", ...allValues];
        } else if (removed === "") {
          updatedValue = [];
        } else if (prev.includes("") && removed) {
          updatedValue = allValues.filter((v) => v !== removed);
        } else {
          updatedValue = incoming.filter((v) => v !== "");
          const isAllSelected = allValues.every((v) =>
            updatedValue.includes(v),
          );
          if (isAllSelected) {
            updatedValue = ["", ...allValues];
          }
        }
        updatedFilters[key] = updatedValue;
      }

      if (key === "status") {
        const allValues = (filterOptions.statusOptions || [])
          .map((o) => o.value)
          .filter((v) => v !== "");
        let incoming = Array.isArray(value) ? value : [value];
        const added = incoming.find((v) => !prev.includes(v));
        const removed = prev.find((v) => !incoming.includes(v));

        if (added === "") {
          updatedValue = ["", ...allValues];
        } else if (removed === "") {
          updatedValue = [];
        } else if (prev.includes("") && removed) {
          updatedValue = allValues.filter((v) => v !== removed);
        } else {
          updatedValue = incoming.filter((v) => v !== "");
          const isAllSelected = allValues.every((v) =>
            updatedValue.includes(v),
          );
          if (isAllSelected) {
            updatedValue = ["", ...allValues];
          }
        }
        updatedFilters[key] = updatedValue;
      }

      if (key === "state") {
        updatedFilters.city = [];
      }
      pendingFiltersRef.current = updatedFilters;
      setFilters(updatedFilters);
    },
    [
      filters,
      filterOptions,
      allCitiesByState,
      cityOptions,
      handleMultiSelectAll,
    ],
  );
  const lastAppliedFiltersRef = React.useRef(null);

  const handleFilterClose = useCallback(
    (key) => {
      const currentFilters = filters || {};

      // Current filters ko stable string me convert karo
      const currentFiltersString = JSON.stringify({
        state: currentFilters.state || [],
        city: currentFilters.city || [],
        store: currentFilters.store || [],
        zone: currentFilters.zone || [],
        productType: currentFilters.productType || [],
        status: currentFilters.status || [],
      });

      // Agar filters change nahi hue to API mat hit karo
      if (lastAppliedFiltersRef.current === currentFiltersString) {
        return;
      }

      lastAppliedFiltersRef.current = currentFiltersString;

      getApprovalList(currentFilters);
    },
    [filters, getApprovalList],
  );
  const handleSnackbarClose = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  const validateFinalSpace = useCallback(
    (productId, finalWidth, finalHeight, availableWidth, availableHeight) => {
      const errors = {};
      if (finalWidth == "" || finalHeight == "") {
        errors.required = "Final dimensions are required.";
      }

      if (Number(finalWidth) > Number(availableWidth)) {
        errors.exceedsWidth = "Final width cannot exceed available space.";
      }

      if (finalHeight > Number(availableHeight)) {
        errors.exceedsHeight = "Final height cannot exceed available space.";
      }

      setValidationErrors((prev) => ({
        ...prev,
        [productId]: errors,
      }));
    },
    [],
  );
  const handleCopyScopeOfWork = useCallback(
    (id, scopeWidth, scopeHeight) => {
      setFinalSpaces((prevSpaces) => {
        const updatedSpaces = prevSpaces.map((space) => {
          if (space.id === id) {
            const availableWidth =
              jobApprovals.find((approval) => approval.product._id === id)?.job
                ?.productDimensionsAfterRecce?.width || 0;

            const availableHeight =
              jobApprovals.find((approval) => approval.product._id === id)?.job
                ?.productDimensionsAfterRecce?.height || 0;

            validateFinalSpace(
              id,
              scopeWidth,
              scopeHeight,
              availableWidth,
              availableHeight,
            );

            return {
              ...space,
              width: scopeWidth || "",
              height: scopeHeight || "",
            };
          }
          return space;
        });

        return updatedSpaces;
      });
    },
    [jobApprovals, validateFinalSpace],
  );

  const updateProductDimensions = useCallback(
    async (id, width, height) => {
      try {
        const response = await fetch(
          `${serverURL}/product/updateProduct/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              approvedWidth: width,
              approvedHeight: height,
              role: role,
            }),
          },
        );

        if (!response.ok) {
          throw new Error(
            `Failed to update product dimensions. Status: ${response.status}`,
          );
        }

        return await response.json();
      } catch (error) {
        console.error("Update dimensions error:", error);
        throw error;
      }
    },
    [serverURL, token, role],
  );

  const handleApproveRow = useCallback(
    async (id, data, type, productId, comment = "", skipRefresh = false) => {
      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];
      const previousFinalSpaces = [...finalSpaces];
      const previousCounts = { ...counts };

      // Prevent socket reload
      updateUserAction(true);

      // Determine client status
      let clientStatus;
      let actionLabel = "";
      if (type === "approve") {
        clientStatus = 1;
        actionLabel = "approved";
      } else if (type === "holdOn") {
        clientStatus = 2;
        actionLabel = "held on";
      } else if (type === "ignore") {
        clientStatus = -1;
        actionLabel = "rejected";
      }
      // OPTIMISTIC UPDATE - Update UI immediately
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval._id === id) {
            return {
              ...approval,
              clientStatus: clientStatus,
              ...(type === "approve" && { clientApprovalReason: comment }),
              ...(type === "holdOn" && { clientHoldOnReason: comment }),
              ...(type === "ignore" && { clientrejectionReason: comment }),
            };
          }
          return approval;
        }),
      );

      // Also update allApprovals
      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval._id === id) {
            return {
              ...approval,
              clientStatus: clientStatus,
              ...(type === "approve" && { clientApprovalReason: comment }),
              ...(type === "holdOn" && { clientHoldOnReason: comment }),
              ...(type === "ignore" && { clientrejectionReason: comment }),
            };
          }
          return approval;
        }),
      );

      // Update counts optimistically
      setCounts((prev) => {
        const newCounts = { ...prev };
        if (type === "approve") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - 1);
          newCounts.approved = (prev.approved || 0) + 1;
        } else if (type === "holdOn") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - 1);
          newCounts.holdOn = (prev.holdOn || 0) + 1;
        } else if (type === "ignore") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - 1);
          newCounts.rejected = (prev.rejected || 0) + 1;
        }
        return newCounts;
      });

      try {
        // Update product dimensions if approving
        if (type === "approve") {
          const finalSpace = finalSpaces.find(
            (space) => space.id === productId,
          );
          if (finalSpace) {
            await updateProductDimensions(
              productId,
              finalSpace.width,
              finalSpace.height,
            );

            setJobApprovals((prevApprovals) =>
              prevApprovals.map((approval) => {
                if (approval._id === id) {
                  return {
                    ...approval,
                    product: {
                      ...approval.product,
                      approvedWidth: parseFloat(finalSpace.width),
                      approvedHeight: parseFloat(finalSpace.height),
                    },
                  };
                }
                return approval;
              }),
            );

            // Also update allApprovals
            setAllApprovals((prevApprovals) =>
              prevApprovals.map((approval) => {
                if (approval._id === id) {
                  return {
                    ...approval,
                    product: {
                      ...approval.product,
                      approvedWidth: parseFloat(finalSpace.width),
                      approvedHeight: parseFloat(finalSpace.height),
                    },
                  };
                }
                return approval;
              }),
            );
          }
        }

        // Build request body
        let requestBody = {
          clientId: localStorage.getItem("clientId"),
          clientStatus: clientStatus,
        };

        // Add reason based on action type
        if (type === "approve") {
          requestBody.clientApprovalReason = comment;
        } else if (type === "holdOn") {
          requestBody.clientHoldOnReason = comment;
        } else if (type === "ignore") {
          requestBody.clientrejectionReason = comment;
        }

        // Set the correct user ID based on role
        if (role == "Admin") {
          requestBody.KAMId = localStorage.getItem("userId");
        } else {
          // Client role - already set above but ensure it's there
          requestBody.clientId = localStorage.getItem("clientId");
        }

        const response = await fetch(
          `${serverURL}/installationPartnerJobApproval/updateApprovalStatus/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || "Failed to update approval status",
          );
        }

        // SHOW SNACKBAR ON SUCCESS
        setSnackbar({
          open: true,
          message: `Job ${actionLabel} successfully`,
          severity: "success",
          autoHideDuration: 2000,
        });

        updateUserAction(false);
      } catch (error) {
        console.error("Approval error:", error);

        // ROLLBACK - Revert to previous state
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);
        setFinalSpaces(previousFinalSpaces);
        setCounts(previousCounts);

        // SHOW SNACKBAR ON ERROR
        setSnackbar({
          open: true,
          message: error.message || `Failed to ${actionLabel} the job`,
          severity: "error",
          autoHideDuration: 2000,
        });

        updateUserAction(false);

        Swal.fire({
          title: "Error",
          text:
            error.message ||
            "There was an issue updating the approval status. Please try again.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    },
    [
      jobApprovals,
      finalSpaces,
      counts,
      updateProductDimensions,
      serverURL,
      token,
      role,
      updateUserAction,
    ],
  );

  const handleActionClick = useCallback((approval, type) => {
    const action = {
      id: approval._id,
      data: approval,
      productId: approval?.product?._id,
      storeName: approval?.job?.storeName || "",
      productType: approval?.product?.productType || "",
    };
    setSelectedAction(action);

    if (type === "approve") {
      setApprovalModalOpen(true);
    } else if (type === "holdOn") {
      setHoldOnModalOpen(true);
    } else if (type === "ignore") {
      setRejectionModalOpen(true);
    }
  }, []);

  const handlePageChange = useCallback(async (e, value) => {
    setPage(value);
  }, []);

  const handleReportOpen = useCallback((approval) => {
    setOpen(true);
    setCurrentApproval(approval);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  // Function to get comment based on status
  const getCommentForStatus = useCallback((approval) => {
    if (approval.clientStatus === 1) {
      return approval.clientApprovalReason || "No reason provided";
    } else if (approval.clientStatus === -1) {
      return approval.clientrejectionReason || "No reason provided";
    } else if (approval.clientStatus === 2) {
      return approval.clientHoldOnReason || "No reason provided";
    }
    return "";
  }, []);

  const isRowSelectable = useCallback(
    (approval) => approval.adminStatus === 1,
    [],
  );

  const selectableCount = useMemo(() => {
    return jobApprovals.filter(isRowSelectable).length;
  }, [jobApprovals, isRowSelectable]);

  const handleBulkCopy = useCallback(() => {
    if (selectedApprovals.length === 0) return;

    const validIds = selectedApprovals.filter((id) => {
      const approval = jobApprovals.find((a) => a._id === id);

      return approval && approval.clientStatus === STATUS.PENDING;
    });

    if (validIds.length === 0) {
      setSnackbar({
        open: true,
        message: "Only pending items can be copied",
        severity: "warning",
        autoHideDuration: 2000,
      });
      return;
    }

    setFinalSpaces((prev) => {
      return prev.map((space, index) => {
        const approval = jobApprovals[index];

        if (!validIds.includes(approval._id)) return space;

        const width = approval?.job?.productDimensionsAfterRecce?.width || "";

        const height = approval?.job?.productDimensionsAfterRecce?.height || "";

        validateFinalSpace(approval.product._id, width, height, width, height);

        return {
          ...space,
          width,
          height,
        };
      });
    });
  }, [selectedApprovals, jobApprovals, validateFinalSpace]);

  const hasFinalSize = useCallback(
    (approval, index) => {
      if (!approval || index === undefined || index === null) return false;

      const width = finalSpaces[index]?.width;
      const height = finalSpaces[index]?.height;

      // Check if both width and height exist and are greater than 0
      return Number(width) > 0 && Number(height) > 0;
    },
    [finalSpaces],
  );

  const handleBulkActions = useCallback(
    async (actionType) => {
      if (selectedApprovals.length === 0) return;

      const permissionMap = {
        approve: (approval) => approval.clientStatus === STATUS.PENDING,
        holdOn: (approval) => approval.clientStatus === STATUS.PENDING,
        ignore: (approval) => approval.clientStatus === STATUS.PENDING,
      };

      const permissionFn = permissionMap[actionType];

      const validIds = selectedApprovals.filter((id) => {
        const approval = jobApprovals.find((a) => a._id === id);

        return approval && permissionFn(approval);
      });

      if (validIds.length === 0) {
        setSnackbar({
          open: true,
          message: "No valid items for this action",
          severity: "warning",
          autoHideDuration: 2000,
        });
        return;
      }

      let textForComment = "";
      let actionLabel = "";
      if (actionType === "approve") {
        textForComment = "Bulk approval";
        actionLabel = "approved";
      } else if (actionType === "holdOn") {
        textForComment = "Bulk hold on";
        actionLabel = "held on";
      } else if (actionType === "ignore") {
        textForComment = "Bulk rejection";
        actionLabel = "rejected";
      }

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];
      const previousCounts = { ...counts };

      // OPTIMISTIC UPDATE - Update all selected approvals
      const clientStatusMap = {
        approve: 1,
        holdOn: 2,
        ignore: -1,
      };
      const newStatus = clientStatusMap[actionType];

      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (validIds.includes(approval._id)) {
            return {
              ...approval,
              clientStatus: newStatus,
              ...(actionType === "approve" && {
                clientApprovalReason: textForComment,
              }),
              ...(actionType === "holdOn" && {
                clientHoldOnReason: textForComment,
              }),
              ...(actionType === "ignore" && {
                clientrejectionReason: textForComment,
              }),
            };
          }
          return approval;
        }),
      );

      // Also update allApprovals
      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (validIds.includes(approval._id)) {
            return {
              ...approval,
              clientStatus: newStatus,
              ...(actionType === "approve" && {
                clientApprovalReason: textForComment,
              }),
              ...(actionType === "holdOn" && {
                clientHoldOnReason: textForComment,
              }),
              ...(actionType === "ignore" && {
                clientrejectionReason: textForComment,
              }),
            };
          }
          return approval;
        }),
      );

      // Update counts optimistically
      const count = validIds.length;
      setCounts((prev) => {
        const newCounts = { ...prev };
        if (actionType === "approve") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - count);
          newCounts.approved = (prev.approved || 0) + count;
        } else if (actionType === "holdOn") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - count);
          newCounts.holdOn = (prev.holdOn || 0) + count;
        } else if (actionType === "ignore") {
          newCounts.pending = Math.max(0, (prev.pending || 0) - count);
          newCounts.rejected = (prev.rejected || 0) + count;
        }
        return newCounts;
      });

      try {
        setIsLoading(true);

        for (const id of validIds) {
          const approval = jobApprovals.find((a) => a._id === id);
          const message =
            role === "Admin"
              ? `${username} ${actionType === "approve" ? "approved" : actionType === "holdOn" ? "held on" : "rejected"} this on behalf of ${client?.name ? client.name : "client"}.`
              : textForComment;
          await handleApproveRow(
            approval._id,
            approval,
            actionType,
            approval?.product?._id,
            message,
            true,
          );
        }

        setSelectedApprovals([]);

        //  SHOW SNACKBAR ON SUCCESS
        setSnackbar({
          open: true,
          message: `${validIds.length} job${validIds.length > 1 ? "s" : ""} ${actionLabel} successfully`,
          severity: "success",
          autoHideDuration: 2000,
        });
      } catch (err) {
        console.error(err);
        // Rollback on error
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);
        setCounts(previousCounts);

        //  SHOW SNACKBAR ON ERROR
        setSnackbar({
          open: true,
          message: `Failed to ${actionType} jobs`,
          severity: "error",
          autoHideDuration: 2000,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [
      selectedApprovals,
      jobApprovals,
      counts,
      handleApproveRow,
      role,
      username,
      client,
    ],
  );

  const handleProductChange = useCallback(
    async (productId, productType, approval) => {
      const price = approval?.campaignId?.rfpId?.products?.find(
        (p) => p.productType === productType,
      )?.costCalculator?.totalCostOfProduct;

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];

      // OPTIMISTIC UPDATE - Update UI immediately
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((item) => {
          if (item.product._id === productId) {
            return {
              ...item,
              product: {
                ...item.product,
                productType: productType,
                price: price || item.product.price,
              },
            };
          }
          return item;
        }),
      );

      // Also update allApprovals to keep search working
      setAllApprovals((prevApprovals) =>
        prevApprovals.map((item) => {
          if (item.product._id === productId) {
            return {
              ...item,
              product: {
                ...item.product,
                productType: productType,
                price: price || item.product.price,
              },
            };
          }
          return item;
        }),
      );

      try {
        await fetch(`${serverURL}/product/updateFinalProduct/${productId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            productType: productType,
            price: price,
            role: role,
          }),
        });

        //  SHOW SNACKBAR ON SUCCESS
        setSnackbar({
          open: true,
          message: "Product type updated successfully",
          severity: "success",
          autoHideDuration: 2000,
        });
      } catch (error) {
        console.error("Product update error", error);
        // Rollback on error
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);

        // SHOW SNACKBAR ON ERROR
        setSnackbar({
          open: true,
          message: "Failed to update product type",
          severity: "error",
          autoHideDuration: 2000,
        });
      }
    },
    [jobApprovals, serverURL, token, role],
  );

  const productOptions = useMemo(() => {
    return (
      productList?.map((product) => ({
        value: product,
        label: product,
      })) || []
    );
  }, [productList]);

  const handleClientCreativeOpen = useCallback((approval) => {
    // if (approval?.adminStatus == 1 && approval?.clientStatus == 1) {
    //   return;
    // }
    setUploadMode("single");

    setSelectedApproval(approval);

    setCreativeFile(approval.job?.clientSideAdaptationImage || "");

    setOpenCreative(true);
  }, []);

  const handleCreativeSave = useCallback(async () => {
    // Save current state for rollback
    const previousJobApprovals = [...jobApprovals];

    // OPTIMISTIC UPDATE - For single upload
    if (uploadMode === "single") {
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                clientSideAdaptationImage: creativeFile,
                creativeDescription: creativeDescription,
              },
            };
          }
          return approval;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                clientSideAdaptationImage: creativeFile,
                creativeDescription: creativeDescription,
              },
            };
          }
          return approval;
        }),
      );
    }

    try {
      setUploadLoading(true);

      if (uploadMode === "single") {
        await axios.put(
          `${process.env.REACT_APP_URL}/jobs/updateJob/${selectedApproval.jobId}`,
          {
            clientSideAdaptationImage: creativeFile,
            creativeDescription: creativeDescription,
            fromWhere: "clientSide",
            uploadFromPortal: role == "Admin" ? "adminPortal" : "clientPortal",
            clientId: role == "Admin" ? null : localStorage.getItem("clientId"),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      }

      // BULK
      if (uploadMode === "bulk") {
        // Bulk upload - update all selected
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: creativeFile,
                  creativeDescription: creativeDescription,
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: creativeFile,
                  creativeDescription: creativeDescription,
                },
              };
            }
            return approval;
          }),
        );

        await Promise.all(
          selectedApprovals.map(async (approvalId) => {
            const approval = jobApprovals.find((a) => a._id === approvalId);

            if (!approval) return;

            if (approval.clientStatus === -1 || approval.clientStatus === 2)
              return;

            await axios.put(
              `${process.env.REACT_APP_URL}/jobs/updateJob/${approval.jobId}`,
              {
                clientSideAdaptationImage: creativeFile,
                creativeDescription: creativeDescription,
                uploadFromPortal:
                  role == "Admin" ? "adminPortal" : "clientPortal",
                clientId:
                  role == "Admin" ? null : localStorage.getItem("clientId"),
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );
          }),
        );
      }

      // 🔥 SAME SOCKET EVENT

      setSnackbar({
        open: true,
        message:
          uploadMode === "bulk"
            ? "Bulk upload successful"
            : "Upload successful",
        severity: "success",
        autoHideDuration: 2000,
      });

      setOpenCreative(false);
    } catch (error) {
      console.error(error);
      // Rollback
      setJobApprovals(previousJobApprovals);
      setAllApprovals(previousJobApprovals);
      setSnackbar({
        open: true,
        message: "Upload failed",
        severity: "error",
        autoHideDuration: 2000,
      });
    } finally {
      setUploadLoading(false);
    }
  }, [
    uploadMode,
    selectedApproval,
    creativeFile,
    creativeDescription,
    selectedApprovals,
    jobApprovals,
    role,
    token,
  ]);

  const handleDeleteUpload = useCallback(async () => {
    // Save current state for rollback
    const previousJobApprovals = [...jobApprovals];

    try {
      const token = localStorage.getItem("token");

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this image?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        confirmButtonColor: "#d33",
        customClass: {
          container: "my-swal",
        },
      });

      if (!result.isConfirmed) return;

      setUploadLoading(true);

      // ✅ UNCOMMENT THIS ENTIRE BLOCK
      // OPTIMISTIC UPDATE
      if (uploadMode === "single") {
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval.jobId === selectedApproval.jobId) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: "",
                },
              };
            }
            return approval;
          }),
        );
        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval.jobId === selectedApproval.jobId) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: "",
                },
              };
            }
            return approval;
          }),
        );
      } else if (uploadMode === "bulk") {
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: "",
                },
              };
            }
            return approval;
          }),
        );
        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  clientSideAdaptationImage: "",
                },
              };
            }
            return approval;
          }),
        );
      }

      if (creativeFile) {
        await axios.post(
          `${serverURL}/deleteUpload`,
          {
            keys: creativeFile,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      }

      /*
      =========================
      2) UPDATE DB — SINGLE
      =========================
      */
      if (uploadMode === "single") {
        await axios.put(
          `${process.env.REACT_APP_URL}/jobs/updateJob/${selectedApproval.jobId}`,
          {
            clientSideAdaptationImage: "",
            creativeDescription: creativeDescription,
            fromWhere: "clientSide",
            uploadFromPortal: role == "Admin" ? "adminPortal" : "clientPortal",
            clientId: role == "Admin" ? null : localStorage.getItem("clientId"),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      }

      /*
      =========================
      3) UPDATE DB — BULK
      =========================
      */
      if (uploadMode === "bulk") {
        await Promise.all(
          selectedApprovals.map(async (approvalId) => {
            const approval = jobApprovals.find((a) => a._id === approvalId);
            if (!approval) return;
            if (approval.clientStatus === -1 || approval.clientStatus === 2)
              return;

            await axios.put(
              `${process.env.REACT_APP_URL}/jobs/updateJob/${approval.jobId}`,
              {
                clientSideAdaptationImage: "",
                creativeDescription: creativeDescription,
                uploadFromPortal:
                  role == "Admin" ? "adminPortal" : "clientPortal",
                clientId:
                  role == "Admin" ? null : localStorage.getItem("clientId"),
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );
          }),
        );
      }

      /*
      =========================
      4) UPDATE UI
      =========================
      */
      setCreativeFile("");

      setSnackbar({
        open: true,
        message:
          uploadMode === "bulk"
            ? "Bulk delete successful"
            : "Image deleted successfully",
        severity: "success",
        autoHideDuration: 3000,
      });

      setOpenCreative(false);
    } catch (error) {
      console.error(error);
      // Rollback
      setJobApprovals(previousJobApprovals);
      setAllApprovals(previousJobApprovals);
      setSnackbar({
        open: true,
        message: "Delete failed",
        severity: "error",
        autoHideDuration: 6000,
      });
    } finally {
      setUploadLoading(false);
    }
  }, [
    uploadMode,
    selectedApproval,
    creativeFile,
    creativeDescription,
    selectedApprovals,
    jobApprovals,
    serverURL,
    role,
    token,
  ]);

  const totalRecceArea = useMemo(() => {
    return (
      jobApprovals
        ?.filter(
          (job) =>
            job?.adminStatus !== -1 &&
            job?.clientStatus !== -1 &&
            job?.clientStatus !== 2,
        )
        ?.reduce((sum, approval) => {
          const recceHeight = approval?.product?.approvedHeight || 0;
          const recceWidth = approval?.product?.approvedWidth || 0;
          return sum + recceHeight * recceWidth;
        }, 0) || 0
    );
  }, [jobApprovals]);

  const pendingFiltersRef = React.useRef(filters);
  // Socket listeners
  useEffect(() => {
    const handleAdminApproved = (data) => {
      getApprovalList(filters, filters.search || "");
    };

    socket.on("admin-Approved", handleAdminApproved);

    return () => {
      socket.off("admin-Approved", handleAdminApproved);
    };
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
    getApprovalList(filters, filters.search || "");
  }, [pageSize, page]);

  useEffect(() => {
    const initialSpaces = jobApprovals.map((approval) => {
      const width = approval?.product?.approvedWidth || 0.0;
      const height = approval?.product?.approvedHeight || 0.0;
      return {
        id: approval?.product?._id,
        width,
        height,
        area: width * height,
      };
    });

    setFinalSpaces(initialSpaces);

    const initialErrors = {};
    initialSpaces.forEach((space) => {
      if (space.width === 0 || space.height === 0) {
        initialErrors[space.id] = {
          required: "Final dimensions are required.",
        };
      }
    });
    setValidationErrors(initialErrors);
  }, [jobApprovals]);

  useEffect(() => {
    if (
      isInitialFilterSetRef.current ||
      !filterOptions.stateOptions?.length ||
      !filterOptions.cityOptions?.length ||
      !filterOptions.storeOptions?.length ||
      !filterOptions.productTypeOptions?.length ||
      !filterOptions.statusOptions?.length
    ) {
      return;
    }

    setFilters({
      state: ["", ...filterOptions.stateOptions.map((item) => item.value)],

      city: ["", ...filterOptions.cityOptions.map((item) => item.value)],

      store: ["", ...filterOptions.storeOptions.map((item) => item.value)],
      zone: ["", ...filterOptions.zoneOptions.map((item) => item.value)],

      productType: [
        "",
        ...filterOptions.productTypeOptions.map((item) => item.value),
      ],

      status: ["", ...filterOptions.statusOptions.map((item) => item.value)],
    });
    lastAppliedFiltersRef.current = JSON.stringify(initialFilters);
    isInitialFilterSetRef.current = true;
  }, [
    filterOptions.stateOptions,
    filterOptions.cityOptions,
    filterOptions.storeOptions,
    filterOptions.zoneOptions,
    filterOptions.productTypeOptions,
    filterOptions.statusOptions,
  ]);

  useEffect(() => {
    const loadProducts = async () => {
      const products = await fetchItemMasterProductList(id);
      setProductList(products);
    };
    loadProducts();
  }, [id, fetchItemMasterProductList]);

  const handleSearchChange = useCallback(
    (value) => {
      setSearch(value);
      setPage(1);

      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      searchTimeoutRef.current = setTimeout(() => {
        const updatedFilters = {
          ...(pendingFiltersRef.current || filters),
          search: value.trim().toLowerCase(),
        };

        pendingFiltersRef.current = updatedFilters;
        setFilters(updatedFilters);

        getApprovalList(updatedFilters, updatedFilters.search);
      }, 300);
    },
    [filters, getApprovalList],
  );

  // Memoize rendered rows for performance
  const renderedRows = useMemo(() => {
    return jobApprovals?.map((approval, index) => {
      const comment = getCommentForStatus(approval);
      const hasComment = comment && comment.trim() !== "";
      const isSelectable = isRowSelectable(approval);

      return (
        <TableRow
          hover
          key={approval._id}
          tabIndex={-1}
          sx={{
            height: "60px",
            "& td": {
              borderBottom: "1px solid #ddd",
            },
            backgroundColor:
              approval.clientStatus === 1
                ? "rgba(0, 255, 0, 0.1)" // Light Green
                : approval.clientStatus === -1
                  ? "rgba(255, 0, 0, 0.1)" // Light Red
                  : approval.clientStatus === 2
                    ? "rgba(255, 255, 0, 0.2)" // Light Yellow
                    : "transparent", // Default
          }}
        >
          <TableCell
            align="center"
            sx={{
              position: "sticky",
              left: 0,
              background: "#fff",
              zIndex: 9,
              borderRight: "1px solid #ddd",
              borderBottom: "1px solid #ddd",
              padding: "4px 8px",
            }}
          >
            <Checkbox
              checked={selectedApprovals.includes(approval._id)}
              onChange={() => {
                setSelectedApprovals((prev) =>
                  prev.includes(approval._id)
                    ? prev.filter((id) => id !== approval._id)
                    : [...prev, approval._id],
                );
              }}
            />
          </TableCell>
          <TableCell
            sx={{
              position: "sticky",
              left: 59,
              background: "#fff",
              zIndex: 10,
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <Tooltip
              title={
                approval?.job?.storeName?.length > 20 || approval?.job?.address
                  ? `${approval?.job?.storeName || "NA"} - ${approval?.job?.address || ""}`
                  : ""
              }
              arrow
            >
              <span
                className={styles.tableRow}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  fontSize: "15px",
                  color: "#000",
                }}
              >
                {approval?.job?.storeName?.length > 40
                  ? `${approval?.job?.storeName.substring(0, 50)}...`
                  : approval?.job?.storeName || "NA"}
              </span>
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  fontSize: "13px",
                  color: "#888",
                }}
              >
                {approval?.job?.address?.length > 40
                  ? `${approval?.job?.address.substring(0, 40)}...`
                  : approval?.job?.address || ""}
              </span>
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
            colSpan={2}
            align="center"
          >
            <div className={styles.tableRow}>{approval?.job?.city || "NA"}</div>
            <div className={styles.tableRow}>
              {approval?.job?.state || "NA"}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className={styles.tableRow}>{approval?.job?.zone || "NA"}</div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className={styles.tableRow}>
              {approval?.job?.productDimensionsAfterRecce?.width !== undefined
                ? parseFloat(
                    approval?.job?.productDimensionsAfterRecce.width,
                  ).toFixed(2)
                : "NA"}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className={styles.tableRow}>
              {approval?.job?.productDimensionsAfterRecce?.height !== undefined
                ? parseFloat(
                    approval?.job?.productDimensionsAfterRecce.height,
                  ).toFixed(2)
                : "NA"}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            {approval?.product?.approvedWidth ? (
              approval?.product?.approvedWidth
            ) : (
              <TextField
                style={{
                  width: "80px",
                  backgroundColor: validationErrors[approval?.product?._id]
                    ?.exceedsWidth
                    ? "#ffcccc"
                    : "",
                }}
                size="small"
                variant="outlined"
                value={finalSpaces[index]?.width || ""}
                onChange={(e) => {
                  let inputValue = e.target.value;

                  // Allow only numbers and a single decimal point
                  if (!/^\d*\.?\d*$/.test(inputValue)) {
                    return; // Ignore invalid input
                  }

                  // Convert only if input is valid
                  const width = inputValue === "" ? "" : parseFloat(inputValue);

                  // Update state correctly
                  setFinalSpaces((prev) => {
                    const updatedSpaces = [...prev];
                    updatedSpaces[index] = {
                      ...updatedSpaces[index],
                      width: inputValue, // Keep as string for immediate UI updates
                    };
                    return updatedSpaces;
                  });
                  const availableWidth =
                    approval?.job?.productDimensionsAfterRecce?.width || 0;
                  const availableHeight =
                    approval?.job?.productDimensionsAfterRecce?.height || 0;

                  validateFinalSpace(
                    approval.product._id,
                    width,
                    finalSpaces[index]?.height || "",
                    availableWidth,
                    availableHeight,
                  );
                }}
                placeholder="Width"
                inputProps={{
                  inputMode: "decimal",
                  pattern: "[0-9]*[.]?[0-9]*",
                }}
              />
            )}
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            {approval?.product?.approvedHeight ? (
              approval?.product?.approvedHeight
            ) : (
              <TextField
                style={{
                  width: "80px",
                  backgroundColor: validationErrors[approval?.product?._id]
                    ?.exceedsHeight
                    ? "#ffcccc"
                    : "",
                }}
                size="small"
                variant="outlined"
                value={finalSpaces[index]?.height || ""}
                onChange={(e) => {
                  let inputValue = e.target.value;
                  if (!/^\d*\.?\d*$/.test(inputValue)) {
                    return;
                  }
                  const height =
                    inputValue === "" ? "" : parseFloat(inputValue);
                  setFinalSpaces((prev) => {
                    const updatedSpaces = [...prev];
                    updatedSpaces[index] = {
                      ...updatedSpaces[index],
                      height: inputValue,
                    };
                    return updatedSpaces;
                  });
                  const availableWidth =
                    approval?.job?.productDimensionsAfterRecce?.width || 0;
                  const availableHeight =
                    approval?.job?.productDimensionsAfterRecce?.height || 0;
                  validateFinalSpace(
                    approval.product._id,
                    finalSpaces[index]?.width || "",
                    height,
                    availableWidth,
                    availableHeight,
                  );
                }}
                placeholder="Height"
                inputProps={{
                  inputMode: "decimal",
                  pattern: "[0-9]*[.]?[0-9]*",
                }}
              />
            )}
          </TableCell>

          <TableCell
            align="center"
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <IconButton
              size="small"
              disabled={approval.clientStatus == 1}
              onClick={() =>
                handleCopyScopeOfWork(
                  approval?.product?._id,
                  approval?.job?.productDimensionsAfterRecce?.width || "",
                  approval?.job?.productDimensionsAfterRecce?.height || "",
                )
              }
              sx={{
                color: approval.clientStatus == 1 ? "#bbb" : "#1976d2",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                },
              }}
            >
              <CopyIcon fontSize="small" />
            </IconButton>
            {/* ❌ Remove this entire block */}
            {/* {finalSpaces[index]?.width && finalSpaces[index]?.height && (
    <CheckCircleOutlineIcon
      sx={{
        color: "#4caf50",
        fontSize: "16px",
        opacity: approval.clientStatus == 1 ? 0.5 : 1
      }}
    />
  )} */}
          </TableCell>
          {/* area */}
          {role == "client" && (
            <TableCell
              sx={{
                padding: "4px 8px",
                borderRight: "1px solid #ddd",
                minWidth: "150px",
              }}
            >
              {(() => {
                const recceHeight =
                  approval?.job?.productDimensionsAfterRecce?.height || 0;
                const recceWidth =
                  approval?.job?.productDimensionsAfterRecce?.width || 0;
                const hasFinalSize =
                  finalSpaces[index]?.width && finalSpaces[index]?.height;
                const finalHeight = hasFinalSize
                  ? Number(finalSpaces[index]?.height)
                  : recceHeight;
                const finalWidth = hasFinalSize
                  ? Number(finalSpaces[index]?.width)
                  : recceWidth;
                const totalArea = finalHeight * finalWidth;

                if (!totalArea)
                  return <span className="text-gray-400">NA</span>;

                return (
                  <div className={styles.tableRow}>
                    {totalArea.toLocaleString()}
                  </div>
                );
              })()}
            </TableCell>
          )}
          {/* product type */}
          {/* <TableCell
                                    sx={{
                                      padding: "4px 8px",
                                      borderRight: "1px solid #ddd",
                                      width: "160px",
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        approval?.product?.productType?.length >
                                        17
                                          ? approval.product.productType
                                          : "" // show tooltip only if text is long
                                      }
                                      arrow
                                      placement="top"
                                    >
                                      <span
                                        className={styles.tableRow}
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "110px",
                                          fontSize: "13px",
                                          display: "inline-block",
                                        }}
                                      >
                                        {approval?.product?.productType
                                          ? approval.product.productType
                                              .length > 17
                                            ? `${approval.product.productType.substring(
                                                0,
                                                17,
                                              )}...`
                                            : approval.product.productType
                                          : "NA"}
                                      </span>
                                    </Tooltip>
                                  </TableCell> */}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              width: "160px",
            }}
          >
            <GlobalDropdownField
              variant="compact"
              name="productType"
              height="40px"
              disabled={approval?.clientStatus != 0}
              value={approval?.product?.productType || ""}
              placeholder="Product"
              options={productOptions}
              onChange={(e) =>
                handleProductChange(
                  approval?.product?._id,
                  e.target.value,
                  approval,
                )
              }
              renderValueFn={(selected) => (
                <span style={{ fontSize: "0.75rem" }}>
                  {selected || "Select Product"}
                </span>
              )}
              useNewStyles
            />
          </TableCell>
          {role == "client" && (
            <TableCell
              sx={{
                padding: "4px 8px",
                borderRight: "1px solid #ddd",
                minWidth: "180px",
                width: "180px",
              }}
            >
              <div className="flex items-center whitespace-nowrap">
                <div className="text-gray-400 text-left">
                  {(() => {
                    const final = finalSpaces[index];
                    const product = approval?.product;
                    const jobDimensions =
                      approval?.job?.productDimensionsAfterRecce || {};
                    let price = null;
                    if (final?.height && final?.width && product?.price) {
                      price = final.height * final.width * product.price;
                    } else if (
                      jobDimensions?.height &&
                      jobDimensions?.width &&
                      product?.price
                    ) {
                      price =
                        jobDimensions.height *
                        jobDimensions.width *
                        product.price;
                    } else {
                      price =
                        product?.productHeight *
                        product?.productWidth *
                        product?.price;
                    }

                    if (price === null)
                      return <span className="text-sm">NA</span>;
                    const formattedPrice = `₹ ${price.toLocaleString()}`;
                    const showTooltip =
                      Math.floor(price).toString().length > 10;
                    return showTooltip ? (
                      <Tooltip title={formattedPrice} arrow>
                        <span
                          className="text-sm font-medium"
                          style={{ cursor: "pointer" }}
                        >
                          ₹ {price.toLocaleString().slice(0, 20)}
                          ...
                        </span>
                      </Tooltip>
                    ) : (
                      <div className={styles.tableRow}>{formattedPrice}</div>
                    );
                  })()}
                </div>
              </div>
            </TableCell>
          )}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
            align="center"
          >
            <IconButton
              size="small"
              sx={{
                padding: "8px 10px",
                color: approval.clientStatus == 1 ? "#bbb" : "#1976d2",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                },
              }}
              onClick={() => handleReportOpen(approval)}
            >
              <ReportIcon width={22} height={30} />
            </IconButton>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className="flex flex-col items-center justify-center">
              <div className="flex items-center gap-1 bg-blue-100 text-gray-400 text-xs py-1 px-2   font-medium rounded-full">
                <PersonOutlinedIcon
                  sx={{
                    fontSize: "15px",
                    color: "#1976d2",
                  }}
                />
                <span className=" text-blue-700 font-semibold">Admin</span>
              </div>
              <span
                className="text-gray-700 text-xs mt-1"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100px",
                  display: "inline-block",
                }}
              >
                {approval?.keyAccountManager?.name
                  ? approval?.keyAccountManager?.name.charAt(0).toUpperCase() +
                    approval?.keyAccountManager?.name.slice(1)
                  : "NA"}
              </span>
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className="flex flex-col items-center justify-center">
              <div
                className="flex items-center gap-1 text-xs py-1 px-2 font-medium rounded-full"
                style={{
                  backgroundColor:
                    approval.clientStatus === 0
                      ? "#D0F4FF"
                      : approval.clientStatus === 1
                        ? "#adff97"
                        : approval.clientStatus === 2
                          ? "#ffe288"
                          : "#ffc8c8",
                  color:
                    approval.clientStatus === 0
                      ? "#093EBC"
                      : approval.clientStatus === 1
                        ? "#358C09"
                        : approval.clientStatus === 2
                          ? "#8C6D09"
                          : "#8C0909",
                }}
              >
                {approval.clientStatus === 0 ? (
                  <AccessTimeOutlinedIcon sx={{ fontSize: 12 }} />
                ) : approval.clientStatus === 1 ? (
                  <ApproveIconWithoutBorder width={8} height={8} />
                ) : approval.clientStatus === 2 ? (
                  <HoldOnWithoutBorder width={10} height={10} />
                ) : (
                  <RejectWithoutBorder width={12} height={12} />
                )}
                <span className="font-semibold">
                  {approval.clientStatus === 0
                    ? "Pending"
                    : approval.clientStatus === 1
                      ? "Approved"
                      : approval.clientStatus === 2
                        ? "Hold On"
                        : "Rejected"}
                </span>
              </div>
              <span
                className="text-gray-700 text-xs mt-1"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100px",
                  display: "inline-block",
                }}
              >
                {approval?.client?.name
                  ? approval.client.name.charAt(0).toUpperCase() +
                    approval.client.name.slice(1)
                  : ""}
              </span>
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
            style={{
              opacity:
                approval.clientStatus == 1 ||
                approval.clientStatus == -1 ||
                approval.clientStatus == 2
                  ? 0.5
                  : 1,
              pointerEvents:
                approval.clientStatus == 1 ||
                approval.clientStatus == -1 ||
                approval.clientStatus == 2
                  ? "none"
                  : "auto",
            }}
          >
            <div className="flex justify-center cursor-pointer items-center">
              <TableCell
                sx={{
                  padding: "4px 8px",
                  borderRight: "1px solid #ddd",
                }}
                style={{
                  opacity:
                    approval.clientStatus == 1 ||
                    approval.clientStatus == -1 ||
                    approval.clientStatus == 2
                      ? 0.5
                      : 1,
                  pointerEvents:
                    approval.clientStatus == 1 ||
                    approval.clientStatus == -1 ||
                    approval.clientStatus == 2
                      ? "none"
                      : "auto",
                }}
              >
                <div className="flex justify-center cursor-pointer items-center">
                  {/* APPROVE BUTTON WITH TOOLTIP */}
                  <Tooltip
                    title={
                      // Check if approve is disabled and why
                      approval.clientStatus === 1 ||
                      approval.clientStatus === -1 ||
                      approval.clientStatus === 2
                        ? "Action not available for this status"
                        : validationErrors[approval?.product?._id]?.required ||
                            validationErrors[approval?.product?._id]
                              ?.exceedsWidth ||
                            validationErrors[approval?.product?._id]
                              ?.exceedsHeight
                          ? "Please copy final dimensions first"
                          : "Approve"
                    }
                    arrow
                  >
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => handleActionClick(approval, "approve")}
                        disabled={
                          !finalSpaces[index]?.width ||
                          !finalSpaces[index]?.height ||
                          validationErrors[approval?.product?._id]?.required ||
                          validationErrors[approval?.product?._id]
                            ?.exceedsWidth ||
                          validationErrors[approval?.product?._id]
                            ?.exceedsHeight ||
                          approval.clientStatus === 1 ||
                          approval.clientStatus === -1 ||
                          approval.clientStatus === 2
                        }
                        sx={{
                          color: approvedProducts[approval?._id]
                            ? "#2e7d32"
                            : "#1976d2",
                          "&:hover": {
                            backgroundColor: approvedProducts[approval?._id]
                              ? "rgba(46, 125, 50, 0.08)"
                              : "rgba(25, 118, 210, 0.08)",
                          },
                          "&.Mui-disabled": {
                            color: "#bbb",
                          },
                        }}
                      >
                        <ApprovIcon />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip
                    title={
                      approval.clientStatus === 1 ||
                      approval.clientStatus === -1 ||
                      approval.clientStatus === 2
                        ? "Action not available for this status"
                        : "Hold On"
                    }
                    arrow
                  >
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => handleActionClick(approval, "holdOn")}
                        disabled={
                          heldProducts[approval?._id] ||
                          approval.clientStatus === 1 ||
                          approval.clientStatus === -1 ||
                          approval.clientStatus === 2
                        }
                        sx={{
                          color: "#ed6c02",
                          "&:hover": {
                            backgroundColor: "rgba(237, 108, 2, 0.08)",
                          },
                          "&.Mui-disabled": {
                            color: "#bbb",
                          },
                        }}
                      >
                        <HoldOnIcon />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip
                    title={
                      approval.clientStatus === 1 ||
                      approval.clientStatus === -1 ||
                      approval.clientStatus === 2
                        ? "Action not available for this status"
                        : "Reject"
                    }
                    arrow
                  >
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => handleActionClick(approval, "ignore")}
                        style={{ margin: "0.2rem" }}
                        fullWidth
                        disabled={
                          approval.clientStatus === 1 ||
                          approval.clientStatus === -1 ||
                          approval.clientStatus === 2
                        }
                        sx={{
                          color: "#d32f2f",
                          "&:hover": {
                            backgroundColor: "rgba(211, 47, 47, 0.08)",
                          },
                          "&.Mui-disabled": {
                            color: "#bbb",
                          },
                        }}
                      >
                        <RejectIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </div>
              </TableCell>
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <div
              style={{ margin: "0.1rem" }}
              // className={`text-blue-500 ${approval.clientStatus == 1 && approval.adminStatus == 1 ? "cursor-not-allowed" : "cursor-pointer"}`}
              className={`text-blue-500 cursor-pointer`}
            >
              {!approval.job.clientSideAdaptationImage ? (
                <p
                  className=""
                  onClick={() => handleClientCreativeOpen(approval)}
                >
                  Upload
                </p>
              ) : (
                <div className="flex justify-center items-center">
                  <ImageOutlined
                    fontSize="small"
                    className="cursor-pointer text-gray-500 hover:text-black"
                    onMouseEnter={(e) => {
                      setHoveredImage(approval.job.clientSideAdaptationImage);
                      setAnchorEl(e.currentTarget);
                    }}
                    onMouseLeave={() => {
                      setHoveredImage(null);
                      setAnchorEl(null);
                    }}
                  />
                  <p
                    onClick={() => handleClientCreativeOpen(approval)}
                    className={``}
                  >
                    Update
                  </p>
                </div>
              )}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              maxWidth: "200px",
            }}
          >
            <div
              className={`${styles.tableRow} flex items-center `}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "180px",
                fontSize: "13px",
              }}
            >
              {approval.approvalReason ? (
                <>
                  {approval.approvalReason.length > 15 ? (
                    <Tooltip
                      title={approval.approvalReason}
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer" }}>
                        {approval.approvalReason.length > 25
                          ? `${approval.approvalReason.substring(0, 25)}...`
                          : approval.approvalReason}
                      </span>
                    </Tooltip>
                  ) : (
                    <span>
                      {approval.approvalReason.length > 25
                        ? `${approval.approvalReason.substring(0, 25)}...`
                        : approval.approvalReason}
                    </span>
                  )}
                </>
              ) : (
                "No comments"
              )}
            </div>
          </TableCell>
          {/* NEW COMMENT COLUMN CELL */}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              maxWidth: "200px",
            }}
          >
            <div
              className={`${styles.tableRow} flex items-center ${
                hasComment ? "text-gray-700" : "text-gray-400"
              }`}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "180px",
                fontSize: "13px",
              }}
            >
              {hasComment ? (
                <>
                  {comment.length > 15 ? (
                    <Tooltip title={comment} arrow placement="top">
                      <span style={{ cursor: "pointer" }}>
                        {comment.length > 25
                          ? `${comment.substring(0, 25)}...`
                          : comment}
                      </span>
                    </Tooltip>
                  ) : (
                    <span>
                      {comment.length > 25
                        ? `${comment.substring(0, 25)}...`
                        : comment}
                    </span>
                  )}
                </>
              ) : (
                "No comments"
              )}
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }, [
    jobApprovals,
    selectedApprovals,
    finalSpaces,
    validationErrors,
    getCommentForStatus,
    isRowSelectable,
    handleCopyScopeOfWork,
    handleProductChange,
    handleReportOpen,
    handleActionClick,
    handleClientCreativeOpen,
    productOptions,
    approvedProducts,
    heldProducts,
    validateFinalSpace,
  ]);

  return (
    <>
      {!campaignListLoading ? (
        <>
          <div>
            <div className="pb-2 flex justify-between items-center">
              <div
                onClick={() => {
                  role !== "Admin"
                    ? navigate(`/user/campaign/${id}`)
                    : setClientApprovalOpen(false);
                }}
                className="cursor-pointer"
              >
                <Back size={27} />
              </div>
              <div className="flex items-center justify-end"></div>
            </div>
            <div>
              <ClientStatCards counts={counts} />
            </div>
            <div className=" flex items-center justify-between gap-4">
              <ClientApprovalFilters
                filters={filters}
                filterOptions={{
                  ...filterOptions,
                  cityOptions: (() => {
                    const allStates = Object.keys(allCitiesByState);
                    const selectedStates =
                      !filters.state ||
                      filters.state.length === 0 ||
                      filters.state.includes("")
                        ? allStates
                        : filters.state.filter((state) => state !== "");
                    const citiesForStates = selectedStates.flatMap(
                      (st) => allCitiesByState[st] || [],
                    );
                    return (filterOptions.cityOptions || []).filter((city) =>
                      citiesForStates.includes(city.value),
                    );
                  })(),
                }}
                onFilterChange={handleFilterChange}
                handleFilterClose={handleFilterClose}
              />
              <div className="mt-4 mb-4 flex items-center justify-between gap-4">
                <TextField
                  size="small"
                  placeholder="Search store / city / product..."
                  value={search}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  sx={{ width: "280px", background: "#fff" }}
                />
                <button
                  disabled={jobApprovals.length == 0}
                  onClick={() => setIsModalOpen(true)}
                  className={`px-4 py-1 h-8 rounded border-2 transition duration-100 flex items-center gap-2 ${
                    jobApprovals.length === 0
                      ? "cursor-not-allowed bg-gray-200 text-black border-gray-300"
                      : "cursor-pointer text-black border-gray-300 hover:bg-blue-500 hover:text-white hover:border-blue-600 group"
                  }`}
                >
                  <RemoveRedEyeOutlinedIcon
                    fontSize="small"
                    sx={{
                      color: "inherit",
                      transition: "color 0.1s",
                    }}
                  />
                  View PPT's
                </button>
              </div>
            </div>

            {isModalOpen && (
              <TemplateModal
                isOpen={isModalOpen}
                recceData={jobApprovals}
                role="client"
                isPreviewCompletionReport={isPreviewCompletionReport}
                onClose={() => setIsModalOpen(false)}
                onRecceStatusChanged={() =>
                  getApprovalList(filters, filters.search || "")
                }
              />
            )}
          </div>
          <Paper
            sx={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: "20px",
            }}
            className="mt-1 pb-1"
          >
            <>
              {isLoading ? (
                <div className="h-[500px] w-full flex items-center justify-center">
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {jobApprovals?.length > 0 ? (
                    <>
                      <TableContainer
                        sx={{
                          height: `${role == "client" ? "calc(85vh - 260px)" : "calc(85vh - 290px)"}`,
                          maxHeight: `${role == "client" ? "calc(85vh - 260px)" : "calc(85vh - 290px)"}`,
                          overflowY: "auto",
                        }}
                        className={`mt-2 rounded-lg ${styles["custom-scrollbar"]}`}
                      >
                        <Table stickyHeader className="rounded-lg">
                          <TableHead>
                            <TableRow
                              hover
                              sx={{
                                whiteSpace: "nowrap",
                                textAlign: "center",
                                position: "sticky",
                                top: 0,
                                zIndex: 11,
                                backgroundColor: "#e6e6e6 !important",
                                borderBottom: "3px solid #333",
                                "& .MuiTableCell-head": {
                                  backgroundColor: "#e6e6e6 !important",
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                sx={{
                                  position: "sticky",
                                  left: 0,
                                  padding: "4px 8px",
                                  zIndex: 20,
                                  width: "50px",
                                  borderRight: "1px solid #ddd",
                                }}
                              >
                                <Checkbox
                                  disabled={selectableCount === 0}
                                  checked={
                                    selectableCount > 0 &&
                                    jobApprovals
                                      .filter(isRowSelectable)
                                      .every((a) =>
                                        selectedApprovals.includes(a._id),
                                      )
                                  }
                                  indeterminate={
                                    selectedApprovals.length > 0 &&
                                    selectedApprovals.length < selectableCount
                                  }
                                  onChange={() => {
                                    const ids = jobApprovals
                                      .filter(isRowSelectable)
                                      .map((a) => a._id);
                                    const allSelected = ids.every((id) =>
                                      selectedApprovals.includes(id),
                                    );
                                    setSelectedApprovals(
                                      allSelected ? [] : ids,
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                p={0}
                                sx={{
                                  position: "sticky",
                                  left: 59,
                                  zIndex: 19,
                                  borderRight: "1px solid #ddd",
                                }}
                                onClick={sortByStoreName}
                              >
                                <div
                                  className={`${styles.tableHead} flex justify-between items-center`}
                                  style={{ lineHeight: 1 }}
                                >
                                  Store Details
                                  {storeSortOrder !== "desc" ? (
                                    <div className="">
                                      <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                    </div>
                                  ) : (
                                    <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                colSpan={2}
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                }}
                              >
                                <div
                                  className={styles.tableHead}
                                  style={{ lineHeight: 1 }}
                                >
                                  {`City & State`}
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  cursor: "pointer",
                                }}
                                onClick={sortByZone}
                              >
                                <div
                                  className={`${styles.tableHead} flex items-center justify-center gap-2`}
                                >
                                  Zone
                                  {zoneSortOrder !== "desc" ? (
                                    <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                  ) : (
                                    <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`${styles.tableHead}`}>
                                  Available Width
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`w-28 ${styles.tableHead}`}>
                                  Available Height
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`w-28 ${styles.tableHead}`}>
                                  Final Width
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`w-28 ${styles.tableHead}`}>
                                  Final Height
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`w-28 ${styles.tableHead}`}>
                                  Action
                                </div>
                                {selectedApprovals.length === 0 ? (
                                  <div className={styles.tableSubHead}></div>
                                ) : (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disabled={selectedApprovals.length === 0}
                                    onClick={handleBulkCopy}
                                  >
                                    Bulk Copy
                                  </Button>
                                )}
                              </TableCell>
                              {role == "client" && (
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: "1px solid #ddd",
                                    height: "40px",
                                  }}
                                >
                                  <div className={styles.tableHead}>Area</div>
                                </TableCell>
                              )}
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  height: "40px",
                                  borderRight: "1px solid #ddd",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  Product Type
                                </div>
                              </TableCell>
                              {role == "client" && (
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: "1px solid #ddd",
                                    height: "40px",
                                    borderRight: "1px solid #ddd",
                                  }}
                                >
                                  <div className={styles.tableHead}>Amount</div>
                                </TableCell>
                              )}
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={`w-28 ${styles.tableHead}`}>
                                  Recce Report
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  height: "40px",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  Admin Status
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  height: "60px",
                                  minWidth: "150px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  Client Status
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                }}
                              >
                                <div className={styles.tableHead}>Actions</div>

                                {selectedApprovals.length !== 0 && (
                                  <div className="flex gap-1 justify-center cursor-pointer items-center">
                                    <Tooltip
                                      title={
                                        selectedApprovals.some((id) => {
                                          const approvalIndex =
                                            jobApprovals.findIndex(
                                              (a) => a._id === id,
                                            );
                                          return !hasFinalSize(
                                            jobApprovals[approvalIndex],
                                            approvalIndex,
                                          );
                                        })
                                          ? "Please copy final dimensions for all selected items first"
                                          : "Approve All"
                                      }
                                      arrow
                                    >
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleBulkActions("approve")
                                          }
                                          disabled={selectedApprovals.some(
                                            (id) => {
                                              const approvalIndex =
                                                jobApprovals.findIndex(
                                                  (a) => a._id === id,
                                                );
                                              return !hasFinalSize(
                                                jobApprovals[approvalIndex],
                                                approvalIndex,
                                              );
                                            },
                                          )}
                                        >
                                          <ApprovIcon width={35} height={35} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>

                                    <Tooltip title="Hold On All" arrow>
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleBulkActions("holdOn")
                                          }
                                        >
                                          <HoldOnIcon width={35} height={35} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>

                                    <Tooltip title="Reject All" arrow>
                                      <span>
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleBulkActions("ignore")
                                          }
                                        >
                                          <RejectIcon width={35} height={35} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  </div>
                                )}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  height: "40px",
                                  padding: "4px 8px",
                                  borderRight: "1px solid #ddd",
                                  borderLeft: "1px solid #ddd",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  Reference Creative
                                </div>
                                {selectedApprovals.length === 0 ? (
                                  <div className={styles.tableSubHead}></div>
                                ) : (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disabled={selectedApprovals.length === 0}
                                    onClick={() => {
                                      setUploadMode("bulk");
                                      setCreativeFile("");
                                      setOpenCreative(true);
                                    }}
                                  >
                                    Bulk Upload
                                  </Button>
                                )}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  height: "40px",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  <div className="flex items-center justify-center">
                                    Admin Comment
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  borderRight: "1px solid #ddd",
                                  height: "40px",
                                }}
                              >
                                <div className={styles.tableHead}>
                                  <div className="flex items-center justify-center">
                                    Remarks
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {renderedRows}
                            {role == "client" && (
                              <TableRow
                                sx={{
                                  borderTop: "2px solid #ddd",
                                  position: "sticky",
                                  bottom: 0,
                                  zIndex: 10,
                                  backgroundColor: "#fff",
                                }}
                              >
                                <TableCell
                                  colSpan={9}
                                  sx={{
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  }}
                                ></TableCell>

                                <TableCell
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                    width: "300px",
                                  }}
                                >
                                  <p className="text-md ">
                                    Total sqft:{totalRecceArea.toFixed(2)}{" "}
                                  </p>
                                </TableCell>
                                <TableCell
                                  colSpan={9}
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                  }}
                                ></TableCell>
                                <TableCell
                                  colSpan={11}
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                  }}
                                ></TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {/* remove comment for pagination */}
                      <hr
                        className="mt-2 bg-gray-200 "
                        style={{
                          border: "0.5px solid var(--light-grey-color)",
                        }}
                      />
                      <div className="flex items-center justify-between ml-2">
                        <FormControl
                          variant="standard"
                          size="small"
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 1,
                            "& .MuiInputBase-root:before": {
                              borderBottom: "none",
                            },
                            "& .MuiInputBase-root:after": {
                              borderBottom: "none",
                            },
                            "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                          }}
                        >
                          <InputLabel
                            id="page-size-label"
                            sx={{
                              position: "static",
                              transform: "none",
                              fontSize: "14px",
                              marginRight: "8px",
                              marginTop: "2px",
                            }}
                          >
                            Rows
                          </InputLabel>
                          <Select
                            labelId="page-size-label"
                            value={pageSize}
                            label="Rows"
                            onChange={(e) => {
                              setPageSize(e.target.value);
                              setPage(1);
                            }}
                          >
                            {pageSizeOptions.map((size) => (
                              <MenuItem key={size} value={size}>
                                {size}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Pagination
                          className="p-2 flex justify-center"
                          count={totalPages}
                          page={page}
                          onChange={handlePageChange}
                          sx={{
                            "& .MuiPaginationItem-root.Mui-selected": {
                              backgroundColor: "#418cff",
                              color: "#fff",
                            },
                            "& .MuiPaginationItem-root.Mui-selected:hover": {
                              backgroundColor: "#3366cc",
                            },
                            "& .MuiPaginationItem-root": {
                              "&:hover": {
                                backgroundColor: "#ddd",
                              },
                            },
                          }}
                        />
                      </div>
                      {/* end remove comment for pagination */}
                    </>
                  ) : (
                    <div className="flex w-full justify-center items-center min-h-[500px]">
                      <div className="text-center space-y-4">
                        <div className="flex justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-16 w-16 text-gray-500 animate-bounce"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h6l6 6v10a2 2 0 01-2 2z"
                            />
                          </svg>
                        </div>

                        <p className="text-xl font-semibold text-gray-700 animate-pulse">
                          No records available for approval
                        </p>

                        <p className="text-sm text-gray-500">
                          Please check again later for new updates.
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Approval Modal */}
              <ClientRecceApprovalModal
                open={approvalModalOpen}
                onClose={() => setApprovalModalOpen(false)}
                onSubmit={(comment) => {
                  const message =
                    role === "Admin"
                      ? `${username} approved this on behalf of ${client ? client.name : "the client"} ${comment ? ` - ${comment}` : ""}`
                      : comment;

                  handleApproveRow(
                    selectedAction.id,
                    selectedAction.data,
                    "approve",
                    selectedAction.productId,
                    message,
                    "",
                  );
                  setApprovalModalOpen(false);
                }}
                storeName={selectedAction.storeName}
                productType={selectedAction.productType}
              />

              {/* Hold On Modal */}
              <ClientRecceHoldOnModal
                open={holdOnModalOpen}
                onClose={() => setHoldOnModalOpen(false)}
                onSubmit={(holdOnReason) => {
                  const message =
                    role === "Admin"
                      ? `${username} held on this on behalf of ${client ? client.name : "the client"} ${holdOnReason ? ` - ${holdOnReason}` : ""}`
                      : holdOnReason;

                  handleApproveRow(
                    selectedAction.id,
                    selectedAction.data,
                    "holdOn",
                    selectedAction.productId,
                    message,
                    "",
                  );
                  setHoldOnModalOpen(false);
                }}
                storeName={selectedAction.storeName}
                productType={selectedAction.productType}
              />

              {/* Rejection Modal */}
              <ClientRecceRejectedModal
                open={rejectionModalOpen}
                onClose={() => setRejectionModalOpen(false)}
                onSubmit={(clientrejectionReason) => {
                  const message =
                    role === "Admin"
                      ? `${username} reject this on behalf of ${client ? client.name : "the client"} ${clientrejectionReason ? ` - ${clientrejectionReason}` : ""}`
                      : clientrejectionReason;
                  handleApproveRow(
                    selectedAction.id,
                    selectedAction.data,
                    "ignore",
                    selectedAction.productId,
                    message,
                    "",
                  );
                  setRejectionModalOpen(false);
                }}
              />
              {hoveredImage && (
                <div
                  style={{
                    position: "fixed",
                    top: anchorEl?.getBoundingClientRect().top + 30,
                    left: anchorEl?.getBoundingClientRect().left,
                    zIndex: 1500,
                    background: "#fff",
                    padding: "8px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  }}
                >
                  <img
                    src={hoveredImage}
                    alt="preview"
                    style={{
                      width: "100px",
                      height: "auto",
                      borderRadius: "6px",
                    }}
                  />
                </div>
              )}
              <Modal
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                open={openCreative}
                // onClose={() => setOpenCreative(false)}
              >
                <Box
                  sx={{
                    width: "75%",
                    bgcolor: "white",
                    borderRadius: 3,
                    p: 4,
                    boxShadow: 24,
                    position: "relative",
                  }}
                >
                  <div className="grid grid-cols-2 gap-6">
                    {/* LEFT SIDE PREVIEW */}
                    <div className=" rounded-xl p-4 shadow-[0_0_15px_rgba(0,0,0,0.15)]">
                      <h2 className="font-semibold text-lg">
                        {selectedApproval?.job?.storeName || "Not Available"}
                      </h2>
                      <p className="text-sm text-gray-500 mb-4">
                        {selectedApproval?.product?.productType ||
                          "No product type specified"}
                      </p>

                      <div className="bg-white rounded-lg p-1 my-6 flex justify-center items-center h-auto border-2 border-solid border-blue-500">
                        {selectedApproval?.job?.imageOfRecceSpace ? (
                          <img
                            src={selectedApproval?.job?.imageOfRecceSpace}
                            alt="Creative Preview"
                            className="object-contain h-full rounded"
                          />
                        ) : (
                          <span className="text-gray-400">
                            No Image Uploaded
                          </span>
                        )}
                      </div>
                    </div>

                    {/* RIGHT SIDE UPLOAD */}
                    <DragDropUpload
                      accept="image/*"
                      maxSize={3 * 1024 * 1024}
                      existingFile={
                        selectedApproval?.job?.clientSideAdaptationImage
                      }
                      onUploadComplete={(url) => {
                        setCreativeFile(url);
                      }}
                      loading={uploadLoading}
                      role="client"
                      setOpen={setOpenCreative}
                      handleSave={handleCreativeSave}
                      handleDelete={handleDeleteUpload}
                      onChangeDescription={(value) =>
                        setCreativeDescription(value)
                      }
                      creativeDescription={
                        selectedApproval?.job?.creativeDescription
                      }
                    />
                  </div>

                  {/* FOOTER BUTTONS */}
                </Box>
              </Modal>

              <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
                className="custom-dialog"
                PaperProps={{
                  className: "custom-dialog-paper",
                }}
              >
                <DialogContent>
                  <RecceReport
                    setOpen={setOpen}
                    open={open}
                    currentApproval={currentApproval}
                    finalSpaces={finalSpaces}
                  />
                </DialogContent>
              </Dialog>
            </>
          </Paper>
        </>
      ) : (
        <div className="flex justify-center items-center h-64">
          <CircularProgress />
        </div>
      )}

      <GlobalSnackbar snackbar={snackbar} handleClose={handleSnackbarClose} />
    </>
  );
};

export default RecceApprovalTable;
